var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_52034","data-name":"Group 52034","transform":"translate(-1105 -149)"},[React.createElement("rect",{"id":"Rectangle_47491","data-name":"Rectangle 47491","width":"22","height":"22","transform":"translate(1105 149)","fill":"none","key":0}),React.createElement("g",{"id":"clock-m","transform":"translate(1108 152)","key":1},[React.createElement("path",{"id":"Path_106546","data-name":"Path 106546","d":"M12.583,10.166H15.75V11.75H11V7h1.583Z","transform":"translate(-3.875 -3.042)","key":0}),React.createElement("path",{"id":"Path_106547","data-name":"Path 106547","d":"M2,9.916a7.916,7.916,0,1,1,7.916,7.916A7.916,7.916,0,0,1,2,9.916ZM9.916,3.583A6.333,6.333,0,1,0,16.25,9.916,6.333,6.333,0,0,0,9.916,3.583Z","transform":"translate(-2 -2)","fillRule":"evenodd","key":1})])]));
}

Clock.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Clock;

Clock.default = Clock;
